import {css} from 'lit';

export const toggleOnDarkStyles = css`

    --_toggle__color: var(--sbkToggleColorFgColorOnDarkDefault);
    --_toggle__color--hover: var(--sbkToggleColorFgColorOnLightHover);
    --_toggle__color--disabled-light: var(--sbkToggleColorFgColorOnDarkDisabled);
    --_toggle__color--hover-nein: var(--sbkToggleColorFgColorOnDarkHover);
    --_toggle__color--light: var(--sbkToggleColorFgColorOnLightDefault);
    --_toggle__color--disabled-dark: var(--sbkToggleColorFgColorOnDarkDisabled);

    --_toggle__border: var(--sbkToggleBorderOnDarkEnabled);
    --_toggle__border--disabled: var(--sbkToggleBorderOnDarkDisabled);
    --_toggle__border--focus: var(--sbkToggleBorderOnDarkFocus);
    --_toggle__border--hover: var(--sbkToggleBorderOnDarkHover);

    --_toggle__bg: var(--sbkToggleColorFgColorOnLightDefault);
    --_toggle__bg--hover: var(--sbkToggleColorBgColorOnDarkHover);
    --_toggle__bg--active: var(--sbkToggleColorBgColorOnDarkSelected);
    --_toggle__bg--disabled: var(--sbkToggleColorBgColorOnDarkDisabled);
    --_toggle__bg--focus: var(--sbkToggleColorBgColorOnDarkFocus);
`;
